//import Clients from './screens/index.vue';
const Clients = () => import('./screens/index.vue')

import { PERMISSIONS_KEYS } from '@/settings/consts/permissions';
import { checkUserPermissions } from '@/services/auth';

const clientsRoutes = [];

if (
  checkUserPermissions([
    PERMISSIONS_KEYS.CLIENT_VIEW,
    PERMISSIONS_KEYS.CLIENT_EDIT,
  ])
) {
  clientsRoutes.push({
    path: '/regras-da-prescricao/clientes',
    name: 'Cadastro / Consulta|Cliente',
    component: Clients,
    meta: {
      icon: 'fa-hospital',
      requiresAuth: true,
    },
  });
}

export { clientsRoutes };
